import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down-2btta",
  "use": "down-2btta-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 8\" id=\"down-2btta\"><path fill-rule=\"evenodd\" d=\"M6 5.602L1.2.8 0 2l6 6.002L12 2 10.8.8 6 5.602z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol